export default "__VITE_ASSET__LTcT2kO3__"